// import { apiRequest } from '@/lib/http'

// 列表数据
const navListData = [
  {
    title: '文章',
    imgurl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAmCAYAAADTGStiAAAB9klEQVRYR+2YwUtUURTGfx+2LOlfiCCEdOeqbBG0Kxfua+vKhURCGIQRqUTUwqULd7YKMpV2CeXChSBIgn+AuWpTroTqkzPcGWKYN29wrs4o3sXMY+be87vn3HPeO98Tadh+ADwGBoEr1d8zfR8Am8BbSSthU/Fh+xUwmQlSZmZa0jMlT5fT7NjNU2BX0t8yC638b7sH6ANmgYhqjOEAfwHuAiuShlsxdtw5tsPBgK8F+Hc6035JO8c12so62zeB78BBgJ0WXcoV3qJNpLD/qSRXFSypkmgnPWq8IrDtb8BQmxtZl3TnfxvdC27T08LlpR5fgHNFoHtDfVFO5/+Mc3lYb6d7s7pjHrdQTrUnT5pL/ZOo0eZLQ90xcMdCfWbAtm8AM8A9oLds41l6rgTdAK4Cq8AW0Kgvvww8AQ5zgT8AI8BDSYtNuszbwDrwIxf4F/C1TBDYngBeA59zgaM3fynpebOztb0NDABjOcFTkl40CXNIl5Aw0dBfOxWw7ZC9kXDXgXlJo1kkTLoNNvQ4yZYl4H5oplCOkvaziLYicPL0fYL+i8yX9KmqndqWqY3AtkPyvkvhDei4pLlqDmQR5gn8BvgI3AIepewNToQ36rviaQ0cFyf0KiKydwGIs9+vz/aaNM3w8uUQ+AlErcZtc0nSXlF5HQEZf5nfLwT3twAAAABJRU5ErkJggg==',
    content1: '全面专业的资讯报道',
    content2: '多家财经及科技媒体内',
    datafrom: [
      {
        name: '金色财经',
        logo: require('../../../assets/images/jinse-logo.png'),
        introduce: '金色财经 在这里，读懂区块链',
        linkto: 'type/jinse/article'
      }
    ]
  },
  {
    title: '快讯',
    imgurl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAmCAYAAADX7PtfAAAEi0lEQVRYR72XeajUdRTFP6edtD2prGixojJbbFdsMUwsKi1pgWijnV5pChGVbbZQ2QZJCyYRGdEmQisV7XtBhWkkbbTYZgXthSfO8P095o0z7834pPvXzPzu73u+995zz70jOjTbGwKXAkuAayT92ckR6sTZ9njgdmCj8t5C4ARJb7V7TtuAti8ErgLyzifAusD6wB8F9KF2QNsCtD0DOL8ceB9wFrAOkM/7AUuB0yTd3Rdon4C2JwM3loOulZRIa2Z7tQI6EfgHOFzSk72B9gpoexTwPLASMEPS1MbDbK8MPAocBvwC7Czpi1agLQFtrwm8B2wDPJ4DJSV1y5jtgcDrwFDgaUljlwdwGnB5of9QSYt7S5XtPYDXgFWAiZIebubfNELbawOfAesB50i6rdRsQMgB7F9q9gRwr6R/y/P4nV0ys5skN4K2AjwPuBn4Chgi6S/bg4AXSg8GaA3gUOBV4JDisxmwCFgdGCPpmXYBk5p9gCskRVXCyPuB3dMGVXptp2av5HKSLit+DwBHA7MkndonoO3BwJelwVO7D23nxmHgKZLm1B9ie3qp2fYF8Egg9fsRGNSY1mVSansC8EjSKSkpSnTRz+9LdC81AJ4JTJcUn/hGEKKzaaXtJH1c798M8ErgYmCepCPKIfFLPWdLuqgBcB4wQNJBdYLwUcCAYyUlxd3WDHA2cFLURdKUukPOBa4H0vz3FNJcAEwCxtYTxHb6dhwwRVKlUrWjmgHOBRLZNEmJtttsh0CRtkha3v0J6JIUTa33S52PK6m+pGWEJf+h+Y4Ra0k3NbKs1HMv4O80uqTfmvjcBYShiXS8pOhszwhtD4ksAVuXZxMkJdqOrYyyq8uLkbxxkn7uTmlRljzYAfi2qEtb863ZbWyHoV1JKRCdfaqIw9JaDW3nNqlNajJCUiZ5v832GOAxYFXg+NRaZbx8kyYN4yTd0m+kngTKSnIG8LKkUQHcCfgggWZlqHK9okBtDwfeKWI/MIBp2Ijsd5Kq5WhF4VXKUyMMMDiAofgbwK/ZU6oha3sD4GRgjqSv27mB7WHA6Gx2mR6FH1uVpStf1wpgZlzIksLWRkph2bPAAWWSj2w17auLlB6eD2wK3CEpGpsIq1G3SNK2FUuj7lH5N4GR0cAM1rqopkrK5tbSbM/KNCkO4cPeZTbmEptUqlMBZq69WyTrwdL8mX2fA1sASc/Bkl5s0XcBCmAsm8KWEf/C/H3Dj/S4pCXdWmr7RCB7ZZq2sj2B9Gj6KSMnDVxviST+R5WSZMWINNZr6+9FaWqX7SHetrPq3QlsXLQysy21jfOufRAnMhjgZOv94rugbOVvV+82mxZZD48BFkvK7pLCRxTSvNljaj81gId0M6s/NrYz3sL6udWC1RKwjyj6/bjPVb9CsH06MExSl+1bgYWSZtrOan+dpOfauU0ngDcAwyWNtp0xNl/SZNtZPTKsK5b2itsJYFaFXbK7/F+AI4DNsxTZTnsskDSpKEkWrk9XaEp7NF8dYDsg9T5tp7QBMERJhPnv2JEtL+CBwA+SMkc7sv8AI+LiWAAzAikAAAAASUVORK5CYII=',
    content1: '行业前沿信息推送 ',
    content2: '7*24小时要闻实时更',
    datafrom: [
      {
        name: '金色财经',
        logo: require('../../../assets/images/jinse-logo.png'),
        introduce: '金色财经 在这里，读懂区块链',
        linkto: 'type/jinse/lives'
      }
    ]
  }
  // {
  //   title: '行情',
  //   imgurl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAmCAYAAADTGStiAAABPElEQVRYR+2XMS5FURCGv79SiT0obECjFjuQiB1YgEqFQlQWYAcisQNRa2zgFfaASvXLkUNuSO6c4dzIi/vK++bMl/nvP3PmiuTP9gZwDuzUo7fAkaRFJpUywRV6D5Rz1/XsHmBgKwPPgm+AbWBT0mMB214HHoA7SbuthWTBT8CVpIMhwPYlsC9pbSpwkfRE0ukX8HF93lxIc2CVdTnAYx0wWcVhB7SaISu17fEOmBA83gETgseNWCVsGoO2m10dxoYmGMzgMJn0adYwNjTBYAyGyZLg5jHYG9zvvSUrnsHvrW37240zv+OPqfcjdbrKN7t6bE2apf6VU5fFXJnbqV9s8j5u/oQJ8yY3kLIiNX20hXkzO1fP2NRCn9lIo9h/CLZ9BhwCK5E8nf5/BS5k+xlY7ZS0Nc1LAf9JxW8fRrxmqxThsQAAAABJRU5ErkJggg==',
  //   content1: '数字货币行情分析',
  //   content2: '可靠、便捷、实时的数据',
  //   datafrom: [
  //     {
  //       name: '金色财经',
  //       logo: require('../../../assets/images/jinse-logo.png'),
  //       introduce: '金色财经 在这里，读懂区块链',
  //       linkto: 'type/jinse/market'
  //     }
  //   ]
  // },
  // {
  //   title: '项目',
  //   imgurl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAmCAYAAADTGStiAAABf0lEQVRYR+2YsUrEQBRFz62s1C8QBC0t/YDFWn9BEWxsLbVQQS3X0kYQ/QWtRbC1tBJFwS9QK6srszsbEjfJsm4SFtyBFCFvOPPy7pvMjSgZtleBHWAZmC6LHfDsC3gA2pJuQqyKJtg+BnaBZ+Aa+BgBPAusAYvAiaS9XHDMNMAugG1J3yNAO1NtTwFnwGZYRBH4FpgDlqqA9hYd4Y/AexH4EziXFOpb6bDdBrYScJ1CSq/c9j5w0AHXLaRccCNCii0Uk+xmbLt+IUkrKYEl4IyQbIe+XRhCUS+SQn+Gkj0BR5Ku4n1XSNJMHtid1KXDGLwBzA8BfpN0GeeuA/eSXjOvVUqLOMk4Ax4CODA0UfA4ggeufpQAlWR8B4Sr6tECWmXgRFxVkse6xpOMKyn1pMa/v07/c8uctNOknf70Bgo2kO5xyHZj7ZRxEk2B+7xTE2DgtM8tNgTu98e26zdoqXN1T6WNO4k0OPxuqNeEp7xTAm7aLWbAEV7bj5a83ecHFAzOwDH0jTQAAAAASUVORK5CYII=',
  //   content1: '一、二级市场项目前瞻',
  //   content2: '区块链行业全球化项目数据平台',
  //   datafrom: [
  //     {
  //       name: 'Hotnode',
  //       logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAAASCAYAAACKN/pgAAAIK0lEQVRoQ+1Ze4xUVxn/fWfuDAvoNlAeLboYYJnHnd2FudRgWR61pjGxpE2JUm3BhEKlWo3YWuyLWomK1j5stDwSNKGV2oBJtQ3+YaJVWNo0unN3l965d4elBWx5KCwN792Zez5z7sy9e3cZdmdtWt2Ek2yy5/Gd+53vd77v/L5viJuxAEAN/CbxT3oDjuryXOjQ8IlgTuA87cHe8txkaGgK5tQ/Ei30Bi70G7vSqdoCmXTyK8T0a1/ALbr17fn8e1VvAIB4Pt4FQqABz1ELvumBNh9bAawMbfg2tWCGN9eM20F4acDHZlAL3q6kwKcbZtQVOfbnYI7wjPmWvanSWiOduheA+vMaSXyu1baPDudgI3GtoevLQPyCr3uxp1DX0dWl8Km6fXSANsanuzJyIAToo9m37B9VBFRPfh9EjweAQnyq1bIOV32qSxdqc6ZMifnDrUeOnP8Ae31oolcArdK0c9KpbzDwnL882lO46s2urtNVin9ky64AWqWprwD6Ybyh/8OQewXQ/3NAZyeT8yIRWs2KtoEmgnEGxCYD203L2QHAVc5rpFNrGLiBwNMAChg5M/4IQkGtueDyytFESyHw+bLDdwiIrRLuBgA3EagG4DxLeta07YCw+MFB6SIidI9HEz1d+AwIWQZtNy17p69LOJg06fEFGom1DGomgMBwmD0C2ksCz1+OFGVSqYVEuBuEzzAwgcDdzPSalPxEu+PkPQI5KMtdgE1grAiUYbxDe5FS/WGz3IEeCu5kpj6S1D98ziTCzAqkSBh68lkQKQZMFSMuYw8V3SWt+fwJQ0+9AMKywSJzMVKo04raoyBaXVrH7SVjUV+6Vt6AJVaZtv2rclcY6dQvAHz9crowY/cFyUscxznp62DoydUMbCQiUUGvLgD1FQDVDD21BYS7LnOW867Lt7U7zp8GBXQwQ3xwQKt8AD1rlVhuRk9uIKIHh5Jk8Oum5Sww9NS24QM6yO6Mg9mcPU2tmJ1O/VQAa6vQZa9pOQtVlm40JJrA4h8AokPJqXk/bTHSqV/6aRwDPQBeJuYTILoVQF15r5M9EPERA6jrukJESIWVkjEYhyD4PllEVghZxyTWE+iGvmgil5/udV8ZM4ZrIm5sBQE/CW5+USYjwBnVNzs7jxl6cmOfh3p77yi68jGhydECkecBagxkI4U69ESimiY6fV2YcZAk3y+BLBFNhcB6Ahb5MpL5zrac82JGT24nojv8cWbeApKbiLVzkt2bhaANAI0OeyjFcJWA1qE8mpkZkDeZubyXz8+JxydwNLIPwDWeSZi/O3jIbcYSANeFblM37cWTnvBwCwuXhty/gLGn0k1lwqIwOMpDJbtfJKKngvUuX5d1nFa/3zR58lhtwngVsrzDAfxq1nJu8Q4+RNpi6MnNIUCLhTPnJu07fPiUkjX0xJ0g8Rv/Oy67cwXEAiLy7KA+5HJhTnuuywx0aZo8NuKOP0DA5JKh8QczZy8x0qkTAMaVxXZlLWdx+PxGOvUdAE+HAdVi2ko/J2fGEeJS0SdohPtAmF/u7xoxhQWJ4jqCWFU2xntZy/nkwMsQ9gBm7DdzdnzYgDKOZnP2FH/vTGrmQhLa3/w+SywC4atEpQoag981LccPe4FKmXTytwT6cglQzqO3OJ9GRf8VLGC+J5tztvQDVJ9RD4rt7w9o9EkQbh941sp9bh8xgDK7D4e86FjWsq8deChDT73Ud3juzFpOcriAMuMdM2dPDwBNJq+nCL0eBpQELwPo7rL3HTFz9iUEytBTO0D4UlnO7j1/8bOxMTXH/H0kcG+bZW8Mn6EpkUhomvDq6KqpNzQySvuZfzGGApUZ+REDKCAXh6s9YHdhNpcPQnZj49RxUXfsfhCu9g7O2JnN2UsrAdqDC9da1sHAuOGQWxWgxE0gUgzXa9Ll5jbHCUBvbGwcp8liFwHjy7rsyObsOww9dQqEj5ek+LWs5dzYz0MbEo+AxQ/DgIqYtlwQ/bgkwicKkWiciHr9NeL06aisrfVSsLHd3XLkACplgQXUGzmmhBf/mxjr2OVWEqIOhHUgZAIjS9zWZtu/V30jnfwaQH3hjflxutj7czcWG3fi7Nnjk2o/9ozv/dUACim7SKMun8AwcJzAj3GRsxSlqSxpHRFmB14Neatpdb4ywGtVKP4dIDcTR86RwM0MfC/MgJWHyhqMinHUDo1vJMte0woU6uvra2tj0W1MkEVxbtW+fYdPjRhAy2nL/SEyMlgE2pW17IBwGOnEjYDo+6UnJDkwD60GUNO2dxsNqQfAeGKoMBgmZ5l4fBY08SYRjRparl/aorz2kb4LwuotPkQg9aR4Hs+MQwVxce6IAtQLn3ryISZaD0CraBTGzqIWXdHR0XEuNB8x0qm/AgEbDKb+W0A9z9eT6l3/wSC67Chq3Xd1dBwPdJmlJ5ZGQNtAqgLVvzGwlYAy8esDVKXimXRiA5geuExBokDMD7fmnCeJm6GqKRNCW79KLfAea27GGlBQElNDR6mlVK3geVgIgYf6qdSDFfR3BG9TeC5TXz8Rsagqp5WfA7zcZtu7KoGSSSduAQsv5VCtl8Ray7K6/X5jPD5d08QqAjWDeBKDToPZBLsvmvb+3ZX29NKaq8d9mwlfINA1KkEn8AG60Luca6KLAVI/9Kt2MptzAm9Q34pqIiggSKan2mw7YKINDfUzolJTuswDYSKr/JbZJMjt4Tc+rFNTIjFNCPoWCcwHk0pj8szYeLZQ2FMb0wKvl+cvPth28OD7vuwsXU8TyZWC6XqFGYPfZ2APu9jsl/7+A8bo886yqk6CAAAAAElFTkSuQmCC',
  //       introduce: '找项目上hotnode',
  //       linkto: 'type/hotnode/project'
  //     }
  //   ]
  // }
]
// 客户列表数据
const customerData = [
  {
    name: '百度',
    logo: require('../../../assets/images/customer/1.png'),
    url: 'https://www.baidu.com/'
  },
  {
    name: '今日头条',
    logo: require('../../../assets/images/customer/2.png'),
    url: 'https://www.toutiao.com/'
  },
  {
    name: '腾讯',
    logo: require('../../../assets/images/customer/3.png'),
    url: 'https://www.qq.com/'
  },
  {
    name: '新浪',
    logo: require('../../../assets/images/customer/4.png'),
    url: 'https://www.sina.com.cn/'
  },
  {
    name: '搜狗搜索',
    logo: require('../../../assets/images/customer/5.png'),
    url: 'https://www.sogou.com/'
  },
  {
    name: '360搜索',
    logo: require('../../../assets/images/customer/6.png'),
    url: 'https://www.so.com/'
  },
  {
    name: '神马',
    logo: require('../../../assets/images/customer/7.png'),
    url: 'https://m.sm.cn/'
  },
  {
    name: '币安',
    logo: require('../../../assets/images/customer/8.png'),
    url: 'https://www.binance.com/zh-CN'
  },
  {
    name: 'Huobi',
    logo: require('../../../assets/images/customer/9.png'),
    url: 'https://www.huobi.com/zh-cn/'
  },
  {
    name: '中金网',
    logo: require('../../../assets/images/customer/10.png'),
    url: 'https://www.cngold.com.cn/'
  }
]
// 接口使用数据
const ApiUsedData = [
  {
    name: '接口种类',
    number: 362
  },
  {
    name: '接口总量',
    number: 5367
  },
  {
    name: '调用次数',
    number: 847286
  },
  {
    name: '服务企业',
    number: 86483
  }
]
// 首页API跳转导航列表
const navApi = {
  getNaveData () {
    return navListData
  },
  getCustomerData () {
    return customerData
  },
  getApiUsedData () {
    return ApiUsedData
  }
}
export default navApi
